import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { VideoPreviewModal } from '../VideoPreview';

interface VideoItemProps {
  videoId: string;
  title?: string;
  onRemove?: () => void;
  showRemoveButton?: boolean;
}

export const VideoItem: React.FC<VideoItemProps> = ({
  videoId,
  title = "Aula",
  onRemove,
  showRemoveButton = true,
}) => {
  const [showPreview, setShowPreview] = useState(false);
  
  const handleVideoClick = () => {
    if (videoId && videoId.trim() !== '') setShowPreview(true);
  };

  const handleRemove = () => {
    if (onRemove) {
      onRemove();
    }
  };

  const formatFileName = (name: string) => {
    if (name.length > 30) {
      return name.substring(0, 27) + '...';
    }
    return name;
  };

  if (!videoId || videoId.trim() === '') {
    return null;
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '8px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '12px 16px',
            backgroundColor: '#F7F8F9',
            borderRadius: '8px',
            cursor: 'pointer',
            width: '300px',
            flex: 'none',
            minWidth: '300px',
            maxWidth: '300px',
          }}
          onClick={handleVideoClick}
        >
          <img
            src="/hub/tracks/video-file.svg"
            alt="Vídeo"
            style={{
              width: '20px',
              height: '20px',
              marginRight: '12px',
              flexShrink: 0,
            }}
          />
          <span
            style={{
              color: '#464646',
              fontSize: '14px',
              fontWeight: '400',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {formatFileName(title)}
          </span>
        </div>
        {showRemoveButton && onRemove && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleRemove();
            }}
            style={{
              width: '40px',
              height: '48px',
              backgroundColor: '#00599C',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
            aria-label="Remover vídeo"
          >
            <FontAwesomeIcon 
              icon={faTimes} 
              style={{ 
                fontSize: '18px',
                color: 'white'
              }} 
            />
          </button>
        )}
      </div>

      <VideoPreviewModal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        videoId={videoId}
        title={title}
      />
    </>
  );
};
